"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SttHeading = _interopRequireDefault(require("../../SttTypography/SttHeading"));
var _UserMenu = _interopRequireDefault(require("./UserMenu"));
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var _styles = require("@material-ui/core/styles");
var _reactResponsive = require("react-responsive");
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Help = _interopRequireDefault(require("@material-ui/icons/Help"));
var _SttCacheManager = _interopRequireDefault(require("../../SttCacheManager"));
var _materialUiPopupState = _interopRequireWildcard(require("material-ui-popup-state"));
var _SttMenu = _interopRequireDefault(require("../../../../dist/lib/SttNavigation/SttMenu"));
var _SttMenuItem = _interopRequireDefault(require("../../../../dist/lib/SttNavigation/SttMenuItem"));
var _SttListItemText = _interopRequireDefault(require("../../../../dist/lib/SttList/SttListItemText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    cabecalho: {
      color: '#828282',
      height: "calc(".concat(theme.spacing(5), "px + 10px) !important"),
      backgroundColor: '#F7F7F7',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    cabecalhoDesktop: {
      height: "".concat(theme.spacing(5), "px !important")
    },
    toolbar: {
      width: '100%',
      paddingLeft: '0px',
      paddingRight: '0px',
      minHeight: '0px'
    },
    nomeSistema: {
      color: '#828282',
      fontSize: '0.85rem',
      fontWeight: '400',
      textAlign: 'center',
      margin: '0 auto'
    },
    menuSobre: {
      right: 20
    },
    menuDuvidas: {
      isplay: 'flex',
      flexFlow: 'column wrap',
      justifyContent: 'center'
    },
    botoes: {}
  };
});
var CabecalhoSuperior = function CabecalhoSuperior(props) {
  var classes = useStyles();
  var _useState = (0, _react.useState)(props.opcoesDuvida),
    _useState2 = _slicedToArray(_useState, 1),
    opcoesDuvida = _useState2[0];
  var titulo = props.titulo,
    config = props.config,
    redirectUrl = props.redirectUrl,
    modo = props.modo;

  /**
   * @deprecated
   */
  var onClickDuvidas = props.onClickDuvidas;

  /**Booleans que tratam se a interface é do tipo desktop, tablet ou mobile */
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: 767
  });
  return /*#__PURE__*/_react["default"].createElement(_AppBar["default"], {
    position: "static",
    className: !isMobile ? "".concat(classes.cabecalho, " ").concat(classes.cabecalhoDesktop) : classes.cabecalho
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    className: classes.toolbar
  }, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
    variant: "h4",
    className: classes.nomeSistema
  }, titulo), onClickDuvidas && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    disableRipple: true,
    size: "small",
    className: classes.menuSobre,
    onClick: function onClick() {
      return onClickDuvidas();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Help["default"], null)) || opcoesDuvida && /*#__PURE__*/_react["default"].createElement(_materialUiPopupState["default"], {
    variant: "popover"
  }, function (popupState) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], _extends({
      disableRipple: true,
      size: "small",
      className: classes.menuSobre
    }, (0, _materialUiPopupState.bindTrigger)(popupState)), /*#__PURE__*/_react["default"].createElement(_Help["default"], null)), /*#__PURE__*/_react["default"].createElement(_SttMenu["default"], _extends({}, (0, _materialUiPopupState.bindMenu)(popupState), {
      className: classes.boxMenuUsuario
    }), opcoesDuvida.onClickNotasAtualizacao && /*#__PURE__*/_react["default"].createElement(_SttMenuItem["default"], {
      onClick: function onClick() {
        popupState.close();
        opcoesDuvida.onClickNotasAtualizacao();
      }
    }, /*#__PURE__*/_react["default"].createElement(_SttListItemText["default"], null, opcoesDuvida.strings.notasAtualizacao)), opcoesDuvida.onClickMateriaisSuporte && /*#__PURE__*/_react["default"].createElement(_SttMenuItem["default"], {
      onClick: function onClick() {
        popupState.close();
        opcoesDuvida.onClickMateriaisSuporte();
      }
    }, /*#__PURE__*/_react["default"].createElement(_SttListItemText["default"], null, opcoesDuvida.strings.materiaisSuporte))));
  }), (config === null || config === void 0 ? void 0 : config.url_base_oauth2) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_UserMenu["default"], {
    config: config
  }), /*#__PURE__*/_react["default"].createElement(_SttCacheManager["default"], {
    config: config,
    redirectUrl: redirectUrl,
    modo: modo
  }))));
};
var _default = CabecalhoSuperior;
exports["default"] = _default;